import { render, staticRenderFns } from "./widgetIframe.vue?vue&type=template&id=e328a9b8&scoped=true&"
import script from "./widgetIframe.vue?vue&type=script&lang=js&"
export * from "./widgetIframe.vue?vue&type=script&lang=js&"
import style0 from "./widgetIframe.vue?vue&type=style&index=0&id=e328a9b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e328a9b8",
  null
  
)

export default component.exports